import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { FullPageSpinner } from '../components/layout/FullPageSpinner';
import { LoginForm } from '../features/auth/components/LoginForm';
import { sessionQueryOptions } from '../features/auth/auth.queries';

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ context, search }) => {
    const data = await context.queryClient.ensureQueryData(sessionQueryOptions);
    if (data?.user) {
      throw redirect({ to: search.redirect ?? '/' });
    }
  },
  pendingComponent: FullPageSpinner,
  component: LoginPage,
});

function LoginPage() {
  const { redirect } = Route.useSearch();
  return (
    <div className="grid min-h-screen place-items-center bg-background px-4">
      <div className="w-full max-w-sm">
        <LoginForm redirectTo={redirect} />
      </div>
    </div>
  );
}
